import { Component, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import {Validators, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AdminService} from '../../shared/services/admin.service';
import {Router} from '@angular/router';
import { DailyDollarRateService } from 'src/app/shared/services/dailydollarrate.service';
import {HttpResponse} from '@angular/common/http';
import {AutocompleteService} from '../../shared/services/autocomplete.service';



@Component({
    selector: 'app-edit-dollar-rate-modal',
    templateUrl: './edit-dollar-rate-modal.component.html',
    styleUrls: ['./edit-dollar-rate-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule]
})
export class EditDollarRateModalComponent {
  
  @Output() refreshRates = new EventEmitter<void>();

  passwordType: string = 'password';
  passwordShown: boolean = false;
  icon: string = 'fa fa-eye-slash';
  form;
  status;
  response;
  responseTwo;
  searching = false;
  searchFailed = false;
  results: any;
  clicked: boolean = false;
  details;

   @Input() rateId!: number; 
  
  constructor(fb: FormBuilder, private dailyDollarRateService: DailyDollarRateService, private adminService: AdminService,
              private toastrService: ToastrService, private router: Router,  private autocompleteService: AutocompleteService) {
    this.form = fb.group({
      rate: ['', Validators.required],
    });
  }

  editRate() {
    this.adminService.getDetails().subscribe(
      data => {
        this.details = data[0];
       
           const dataToSubmit = {
    rate: Number(this.form.value.rate),
    uploaded_by: this.details.id
  }

  this.clicked = true;
    this.dailyDollarRateService.editRate(dataToSubmit,this.rateId).subscribe(
      data => {
        this.response = data;
        // this.responseTwo = responseArray[1];
        this.clicked = false;
        if (this.response.status) {
          this.toastrService.success(this.response.message);
          this.closeModal();
          
          this.toastrService.error(this.response.message);
        }
      },
      (error: HttpResponse<any>) => {
         this.toastrService.error(error.statusText);
        //  console.log(error);
         this.clicked = false;
      }
    );
     window.location.reload();
     this.form.reset()

      });

 
  }
  closeModal() {
 this.form.reset()
    const modalClose: HTMLElement = document.getElementById('closeModal') as HTMLElement;
    modalClose.click();
  }
  get rate() {
    return this.form.get('rate');
  }

}


